export default "__VITE_ASSET__DLjs_q2l__"